/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
    baseStyle: {
        maxW: null,
        maxWidth: 'container.xxl'
    },
    variants: {
        'no-padding': {
            px: 0
        },
        checkoutConstrainedForm: {
            maxWidth: '400px',
            px: 0,
            ml: 0
        },
        checkoutSaveMyDetails: {
            backgroundColor: 'stokkePink.mid',
            padding: 6,
            mt: {base: 8, md: 6}
        },
        checkoutStepSummary: {
            // clear defaults from chakra
            mx: null,
            px: null,
            // clear defaults from baseStyle
            maxWidth: null,
            // apply padding only on start
            paddingStart: 7
        },
        CRO001_1_checkoutStepSummary: {
            // clear defaults from chakra
            mx: null,
            px: null,
            // clear defaults from baseStyle
            maxWidth: null
        },
        footer: {
            px: {
                base: 4,
                md: 8
            }
        },
        form: {
            maxWidth: '522px',
            px: 0
        },
        newsLetterBanner: {
            justifyContent: 'center',
            display: 'inline-flex',
            alignItems: 'center',
            marginX: 'auto',
            backgroundColor: 'stokkeBeige.bright',
            paddingY: {base: 12, lg: 16},
            paddingX: {base: 0, lg: '14.5rem', xl: 0},
            maxWidth: 'unset'
        },
        newsLetterBannerInner: {
            padding: 0,
            maxWidth: {
                // The maxWidth is intentionally increased with 32px to compensate for the paddings in the container.
                // The inner container of the component has paddings of 16px left and right.
                // It is necessary to have this paddings because of the shrinkable and expandable container which has overflow hidden.
                // Without this paddings when a field is focused the outline border is clipped from left and right.
                xl: '50rem',
                '2xl': '64rem'
            }
        },
        drawerMenu: {
            display: 'flex',
            width: '100%',
            minHeight: 0,
            gap: 8,

            px: {base: 6, xl: 8},
            paddingTop: 2,
            paddingBottom: 6
        }
    }
}
